import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

// Retorna os cadastros de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/mais-acesso-aps/${cod_ibge}/equipe/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export async function getCadastrosPorMicroArea(cod_ibge, nu_ine, micro_area) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/mais-acesso-aps/${cod_ibge}/equipe/${nu_ine}/microarea/${micro_area}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Retorna o nome da cor de acordo com o valor
 * @param {int} valor - Valor numérico
 */
export function getCorTextoResultado(valor) {
  if (valor >= 60) {
    return 'green-color'
  } else {
    return 'red-color'
  }
}

/**
 * Retorna o nome da cor para pintar a linha da tabela
 */
export function printTableRow(item) {
  if (item.num_mais_acesso >= 1) {
    return 'green'
  } else {
    return 'orange'
  }
}

export function generatePdf(cadastros, selectEquipe, micro_area) {
  let title_pdf = 'Mais acesso'
  let titlePdfSave = utils.methods.titlePdf('Mais acesso')

  let description_pdf =
    'Mais Acesso à APS. Demanda programada vs demanda espontânea'
  let headers_pdf = ['NOME', 'NASCIMENTO', 'MÃE', 'ATENDIMENTO']
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    let dados = JSON.parse(cadastros[i].dados)
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento =
      utils.methods.formatDate(cadastros[i].dt_nascimento) +
      `\n(${cadastros[i].idade} ${cadastros[i].idade > 1 ? 'anos' : 'ano'})`
    obj.no_mae = cadastros[i].no_mae
    obj.atendimento =
      dados != null ? utils.methods.formatDate(dados.dt_atendimento) : ''
    obj.num_mais_acesso = cadastros[i].num_mais_acesso
    data_pdf.push(obj)
  }

  let doc = new jsPDF({
    orientation: 'l',
    unit: 'pt',
    format: 'a4',
    ...utils.methods.encryptionPdf(),
  })
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf,
        200,
        'l'
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Microárea',
            value: micro_area,
          },
        ],
        verticalPosition,
        'l'
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          let num_mais_acesso = data.row.raw[4]
          if (num_mais_acesso >= 1) {
            doc.setTextColor(2, 99, 57) // verde
          } else {
            doc.setTextColor(255, 165, 0) // laranja
          }
          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY, 250, 600, 'l')

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export function percentualMunicipio(dadosDaTabelaResultado) {
  let numerador = 0
  let denominador = 0
  let resultado = 0
  let classificacao = ''

  const hoje = new Date()
  const mesAtual = hoje.getMonth() + 1
  const anoAtual = String(hoje.getFullYear())
  const mesAnoAtual = `${mesAtual}/${anoAtual}`

  const dadosDoMunicipio = dadosDaTabelaResultado.find(
    (item) =>
      item.nivel == 1 &&
      item.ibge === store.state.cod_ibge &&
      item.indicador == 46 &&
      item.mes_ano === mesAnoAtual
  )

  if (dadosDoMunicipio === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
      classificacao: '',
    }
  }

  let dados = JSON.parse(dadosDoMunicipio.dados)

  numerador = dados.numerador
  denominador = dados.denominador
  resultado = dados.resultado
  classificacao = dados.classificacao

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
    classificacao: classificacao,
  }
}

export function percentualEquipe(dadosDaTabelaResultado, nuIne) {
  let numerador = 0
  let denominador = 0
  let resultado = 0
  let classificacao = ''

  const hoje = new Date()
  const mesAtual = hoje.getMonth() + 1
  const anoAtual = String(hoje.getFullYear())
  const mesAnoAtual = `${mesAtual}/${anoAtual}`

  let dadosDaEquipe = dadosDaTabelaResultado.find(
    (item) =>
      item.nivel == 2 &&
      item.ine === nuIne &&
      item.indicador == 46 &&
      item.mes_ano === mesAnoAtual
  )

  if (dadosDaEquipe === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
      classificacao: '',
    }
  }

  let dados = JSON.parse(dadosDaEquipe.dados)

  numerador = dados.numerador
  denominador = dados.denominador
  resultado = dados.resultado
  classificacao = dados.classificacao

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
    classificacao: classificacao,
  }
}

export function percentualMicroArea(
  dadosDaTabelaResultado,
  nu_ine,
  micro_area
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0
  let classificacao = ''

  const hoje = new Date()
  const mesAtual = hoje.getMonth() + 1
  const anoAtual = String(hoje.getFullYear())
  const mesAnoAtual = `${mesAtual}/${anoAtual}`

  let dadosDaMicroArea = dadosDaTabelaResultado.find(
    (item) =>
      item.nivel == 3 &&
      item.ine == nu_ine &&
      item.micro_area === micro_area &&
      item.indicador == 46 &&
      item.mes_ano === mesAnoAtual
  )

  if (dadosDaMicroArea === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
      classificacao: classificacao,
    }
  }

  let dados = JSON.parse(dadosDaMicroArea.dados)

  numerador = dados.numerador
  denominador = dados.denominador
  resultado = dados.resultado
  classificacao = dados.classificacao

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
    classificacao: classificacao,
  }
}
